import PeriodResults from '@/components/kpi/period-results/PeriodResults.vue';
import KpiBaseDataEdit from '@/components/kpi/employees-kpi/kpi-base-data-edit/KpiBaseDataEdit.vue';
import TableviewExtended from '@/components/common/TableviewExtended/TableviewExtended.vue';

const defaultFilterValues = {
  userFullName: null,
  directManagerId: null,
  employeeRole: null,
  department: null,
  division: null,
  isKpiEnabled: ['1']
};

export default {
  name: 'EmployeesKPI',
  components: { KpiBaseDataEdit, PeriodResults, TableviewExtended },
  data () {
    return {
      isMounted: false,
      isLoading: false,
      isUpdating: false,
      isFileLoading: false,
      paging: {
        page: 1,
        pages: 1,
        limit: 20,
        total: 0
      },
      tableSorting: { item: 'title', direction: 'asc' },
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableItems: [],
      structure: null,
      downloadFilters: {
        startDate: null,
        endDate: null
      },
      tableClassDefault: 'table-striped table-hover',
      tableClass: this.tableClassDefault
    }
  },
  computed: {
    employeeRoles () {
      return [
        { value: 'DEPARTMENT_MANAGER', text: 'Departamenta vadītājs' },
        { value: 'DIVISION_MANAGER', text: 'Nodaļas vadītājs' },
        { value: 'EMPLOYEE', text: 'Darbinieks' }
      ]
    },
    showDepartmentHeadUsersLogic () {
      return this.structure?.kpi_managers?.length > 0;
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions(0);
    },
    periodTypes () {
      const types = this.$store.getters.getConfigOptions('period_types');
      types.forEach(type => {
        type.text = this.$t('general.period_types.' + type.value);
      });
      return types;
    },
    companies () {
      return this.$store.getters.getConfigOptions('user_companies', this.$i18n.locale, 'disabled', '0');
    },
    kpiResultStatuses () {
      return this.$store.getters.getConfigOptions('kpi_result_statuses', this.$i18n.locale);
    },
    canViewAll () {
      return this.ApiRequest.userHasPermission('view-all-kpi');
    },
    tableExpandConfig () {
      return { component: 'slot' };
    },
    requestPath () {
      const path = 'kpi/user-company-job-positions?perPage=' + this.paging.limit + '&page=' + this.paging.page;
      return this.ApiRequest.addGetParamsToPath(
        path,
        this.filterValues,
        true
      );
    },
    tableHeaders () {
      let divisions = [];
      let seeEmployees = [];
      if (this.showDepartmentHeadUsersLogic) {
        divisions = [
          { key: 'job_position.department.name.' + this.$i18n.locale, label: this.$t('Departaments'), class: 'col-width-xl', filterKey: 'department' },
          { key: 'job_position.division.name.' + this.$i18n.locale, label: this.$t('Nodaļa'), class: 'col-width-xl', filterKey: 'division' }
        ];
        seeEmployees = [
          { key: 'kpi_manager_name', label: 'Tiešais vadītājs', class: 'col-width-xl' }
        ];
      }
      const headers = [
        { key: 'contractAxId', label: this.$t('kpi.contract_id'), class: 'col-width-xl' },
        { key: 'user.fullname', label: this.$t('kpi.employee'), class: 'col-width-xl', filterKey: 'userFullName' },
        ...divisions,
        { key: 'job.name.' + this.$i18n.locale, label: this.$t('kpi.job_position'), class: 'col-width-xl' },
        ...seeEmployees,
        { key: 'user_kpi_data.salary', label: this.$t('kpi.salary'), class: 'col-width-xl', type: 'slot', slotcode: 'salary' },
        { key: 'companyValidFrom', label: this.$t('kpi.job_position_start_date'), class: 'col-width-xl' },
        { key: 'is_kpi_enabled', label: this.$t('kpi.is_kpi_enabled'), class: 'col-width-xl', type: 'slot', slotcode: 'isKpiEnabled', filterKey: 'isKpiEnabled' },
        { key: 'user_kpi_data.kpi_bonus_rate', label: this.$t('kpi.bonus_rate'), class: 'col-width-xl' },
        { key: 'user_kpi_data.period_type', label: this.$t('kpi.job_position_period_type'), format: 'formatFunc', funcs: [this.getPeriodType], class: 'col-width-xl' }
      ];

      const actions = [];
      actions.push({
        ifconfig: { useFunc: true, func: this.canEdit },
        label: this.$t('kpi.edit-user-kpi-base-data'),
        emit: 'editItem',
        bicon: 'pencil-fill',
        class: 'btn-warning btn-sm'
      });
      headers.push({ key: 'actions', label: '', actions: actions, headerClass: 'col-1' });
      return headers;
    },
    tableActions () {
      return { download: false };
    },
    tableFilterConfig () {
      const filters = {}

      filters.userFullName = {
        type: 'text',
        colOnlyFilter: true,
        label: this.$t('user.name'),
        class: 'col-md-2'
      }
      filters.isKpiEnabled = {
        type: 'checkbox',
        options: this.yesNoOptions,
        colOnlyFilter: true,
        label: this.$t('kpi.is_kpi_enabled'),
        valueField: 'code',
        class: 'col-md-2'
      }
      if (this.showDepartmentHeadUsersLogic) {
        filters.directManagerId = {
          type: 'select',
          options: this.structure?.kpi_managers,
          colOnlyFilter: false,
          label: this.$t('Tiešais vadītājs'),
          valueField: 'id',
          class: 'col-md-2'
        }
        filters.division = { type: 'text', label: '', colOnlyFilter: true }
        filters.department = { type: 'text', label: '', colOnlyFilter: true }
      }

      if (Object.keys(filters).length < 1) {
        return null;
      }

      return filters;
    }
  },
  methods: {
    changeIsKpiEnabled (item, value) {
      const data = { is_kpi_enabled: value };
      this.isUpdating = true;
      this.ApiRequest.request('kpi/user-company-job-positions/' + item.id + '/change', this.ApiRequest.REQUEST_POST, data, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
          this.tableItems[parseInt(item.itemIndex)].is_kpi_enabled = !value;
        }
        this.$store.commit(
          'toastAdd',
          {
            context: 'success',
            message: this.$t('kpi.is_kpi_enabled_changed',
              { fullname: item.user.fullname, status: value ? 'iespējots' : 'atspējots' })
          }
        );
        this.isUpdating = false;
      });
    },
    getRowClass (row) {
      if (row._showDetails) {
        return 'expanded';
      } else {
        return '';
      }
    },
    toggleRow (row) {
      if (row._showDetails) {
        this.tableClass = this.tableClass + ' has-expanded-row';
      } else {
        this.tableClass = this.tableClassDefault;
      }
    },
    canEdit (item) {
      if (this.isLoading || this.isUpdating) {
        return false;
      }
      if (this.ApiRequest.userHasPermission('kpi-admin')) {
        return true;
      }
      return (item?.kpi_direct_manager_id === null && item?.direct_manager_id == this.$session.get('userId')) ||
            (item?.kpi_direct_manager_id == this.$session.get('userId'))
    },
    downloadFile () {
      this.isFileLoading = true;
      this.ApiRequest.request(this.requestPath + '&download=1', this.ApiRequest.REQUEST_DOWNLOAD, [], (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        }
        this.isFileLoading = false;
        this.$refs['modal-window'].hide();
      });
    },
    download () {
      this.$refs['modal-window'].show();
    },
    updateUserCompanyJobPosition (el) {
      //
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    getPeriodType (val) {
      if (val) {
        return this.$t('general.period_types.' + val);
      }
    },
    getTableData () {
      this.isLoading = false;
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.isLoading = true;
      this.$forceUpdate();
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, [], (response) => {
        if (response.data) {
          this.tableItems = response.data.items;
          // if we have structure we dont want to update it because then we would get less direct managers
          if (!this.structure) {
            this.structure = response.data.structure;
          }
          this.paging = response.paging;
          this.isLoading = false;
        }
      });
    },
    changePage (pageNr) {
      this.tableClass = this.tableClassDefault;
      this.paging.page = pageNr;
      this.getTableData();
    },
    updateFilters () {
      this.tableClass = this.tableClassDefault;
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.getTableData();
    },

    clearFilters () {
      this.tableClass = this.tableClassDefault;
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.getTableData();
    }
  },
  mounted () {
    this.filterValues.directManagerId = null; // otherwise backend need to return all possible managers based on query without filtering by directManagerId
    this.getTableData();
    this.isMounted = true;
  }
}
